var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.0841H46",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.913 14.828H44.4348C44.8499 14.828 45.248 14.9929 45.5416 15.2864C45.8351 15.58 46 15.9781 46 16.3932V39.8715C46 40.2866 45.8351 40.6847 45.5416 40.9783C45.248 41.2718 44.8499 41.4367 44.4348 41.4367H11.5652C11.1501 41.4367 10.752 41.2718 10.4584 40.9783C10.1649 40.6847 10 40.2866 10 39.8715V16.3932C10 15.9781 10.1649 15.58 10.4584 15.2864C10.752 14.9929 11.1501 14.828 11.5652 14.828H24.087",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6957 28.9163H42.087",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6957 33.6091H38.1739",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5073 37.5225C28.8687 36.5365 26.751 35.8196 24.0995 34.8382C23.3513 34.5596 23.4734 32.6062 23.8052 32.2415C24.333 31.6699 24.7338 30.9931 24.9815 30.2556C25.2291 29.518 25.3179 28.7365 25.2421 27.9622C25.2874 27.4797 25.2299 26.9931 25.0732 26.5344C24.9165 26.0758 24.6643 25.6557 24.3332 25.3018C24.0021 24.9479 23.5997 24.6684 23.1525 24.4816C22.7053 24.2948 22.2236 24.205 21.7391 24.2182C21.2547 24.205 20.7729 24.2948 20.3258 24.4816C19.8786 24.6684 19.4761 24.9479 19.145 25.3018C18.8139 25.6557 18.5617 26.0758 18.405 26.5344C18.2484 26.9931 18.1908 27.4797 18.2362 27.9622C18.1603 28.7365 18.2492 29.518 18.4968 30.2556C18.7444 30.9931 19.1453 31.6699 19.673 32.2415C20.0049 32.6062 20.1269 34.5596 19.3788 34.8382C16.7304 35.8196 14.6096 36.5365 13.9709 37.5225",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9131 17.1741C31.9131 17.3817 31.8307 17.5807 31.6839 17.7275C31.5371 17.8743 31.3381 17.9567 31.1305 17.9567H24.8696C24.6621 17.9567 24.463 17.8743 24.3163 17.7275C24.1695 17.5807 24.087 17.3817 24.087 17.1741V12.4785C24.087 11.4407 24.4993 10.4454 25.2331 9.71153C25.967 8.9777 26.9623 8.56543 28.0001 8.56543C29.0379 8.56543 30.0332 8.9777 30.767 9.71153C31.5009 10.4454 31.9131 11.4407 31.9131 12.4785V17.1741Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.36f1754fdf7dae36d68e8ba9485d4c8c.svg";
export { ForwardRef as ReactComponent };